import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.QBooksMatchingPopup.QBooksMatchingPopupContent', {
    matchLines: 'Match lines',
    matchTooltip: 'Match',
    showHelp: 'Show the context help',
});
